import { Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react'
import type { ReactElement } from 'react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import type { FileDetailsResponse } from '../../../interfaces/FileDetailsResponse'
import CustomMetadata from './CustomMetadata'
import CustomMetadataForm from './CustomMetadataForm'
import ThreadList from './Threads/ThreadList'

const MLRightSidebar = ({
  fileDetails,
  tabIndex,
  setTabIndex,
}: {
  fileDetails: FileDetailsResponse
  tabIndex: number
  setTabIndex: React.Dispatch<React.SetStateAction<number>>
}): ReactElement => {
  const { t } = useTranslation()

  return (
    <Tabs
      onChange={index => void setTabIndex(index)}
      defaultIndex={tabIndex}
      display="flex"
      flexDirection="column"
      minHeight="100%"
      height="100%"
      size="xl"
    >
      <TabList borderLeft="1px solid rgba(0, 0, 0, .1)">
        <Tab flexGrow={1}>{t('custom_metadata', 'Custom Metadata')}</Tab>
        <Tab flexGrow={1}>{t('comments', 'Comments')}</Tab>
      </TabList>

      <TabPanels minHeight="0" display="flex" flexGrow={1}>
        <TabPanel
          display="flex"
          flexGrow={1}
          width="21vw"
          borderLeft="1px solid rgba(0, 0, 0, .1)"
        >
          {fileDetails.type === 'file' ? (
            <CustomMetadataForm fileDetails={fileDetails} />
          ) : (
            <CustomMetadata fileDetails={fileDetails} />
          )}
        </TabPanel>
        <TabPanel
          display="flex"
          flexGrow={1}
          width="21vw"
          borderLeft="1px solid rgba(0, 0, 0, .1)"
          p="0"
        >
          <ThreadList fileDetails={fileDetails} />
        </TabPanel>
      </TabPanels>
    </Tabs>
  )
}

export default MLRightSidebar
